import type { PinturaEditorDefaultOptions } from '@pqina/pintura'

export const imageEditorProps = ref<PinturaEditorDefaultOptions>({})
